import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { text } from '../constants'
import type { NewServiceVisitType } from '../types'

type FormsErrorsMessages = {
  consentFormError: string
  intakeFormError: string
}

export const checkFromsErrors = (
  serviceType: Pick<NewServiceVisitType, 'ConsentForms' | 'IntakeFormId'>,
): FormsErrorsMessages => {
  const { ConsentForms, IntakeFormId } = serviceType
  const consentForms = ConsentForms?.some((consentForm) => consentForm.isActive)

  const formsErrorsMessages: FormsErrorsMessages = {
    consentFormError: '',
    intakeFormError: '',
  }

  if (!consentForms) {
    formsErrorsMessages.consentFormError = getUserFriendlyErrorMessage(
      errorCodes.FIELD_REQUIRED,
      null,
      text.CONSENT_FORMS,
    )
  }
  if (!IntakeFormId) {
    formsErrorsMessages.intakeFormError = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.INTAKE_FORM)
  }

  return formsErrorsMessages
}
